var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories"},_vm._l((_vm.categories),function(cat){return _c('div',{staticClass:"category",on:{"click":function($event){_vm.seeCategoryJokes(cat)}}},[_vm._v("\n    "+_vm._s(cat)+"\n    "),_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be5c724","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Categories.vue
// module id = 50
// module chunks = 0